import React, { useMemo } from 'react';
import PlaceholderAvatarIcon from 'src/components/Icons/PlaceholderAvatarIcon';
import TrashIcon from 'src/components/Icons/TrashIcon';
import Typography from 'src/components/Typography';
import { Box } from 'src/components/UI/Box';
import { Flex } from 'src/components/UI/Flex';
import { IconButton } from 'src/components/UI/IconButton';
import { Assistant, ASSISTANT_STATUS_ENUM } from 'src/services/AssistantService';

interface AssistantCardProps {
  data: Assistant;
  onRemove(): void;
}

const PENDING_TYPES = [ASSISTANT_STATUS_ENUM.COMPLETE_REGISTRATION_PENDING, ASSISTANT_STATUS_ENUM.ACTIVATION_PENDING];

export default function AssistantCard(props: AssistantCardProps) {
  const { data, onRemove } = props;
  const { assistant } = data;

  const textColor = useMemo(() => {
    if (PENDING_TYPES.includes(assistant.accountStatus)) {
      return 'alert.dark';
    }

    return 'success.dark';
  }, [assistant.accountStatus]);

  const label = useMemo(() => {
    if (PENDING_TYPES.includes(assistant.accountStatus)) {
      return 'Convite enviado pendente de confirmação';
    }

    return 'Convite aceito, pode gerenciar pacientes';
  }, [assistant.accountStatus]);

  return (
    <Flex
      w={'100%'}
      p={'20px'}
      borderRadius={'10px'}
      bg={'#fff'}
      boxShadow={'3px 3px 10px 0px rgba(61, 14, 107, 0.10)'}
      gap={'10px'}
      alignItems={'center'}
    >
      <PlaceholderAvatarIcon variantColor="secondary.200" />

      <Flex gap={'10px'} justifyContent={'space-between'} w={'100%'}>
        <Flex flexDir={'column'} gap={'5px'}>
          <Typography model="body" size="normal" weight="regular">
            {assistant.email}
          </Typography>
          <Typography model="body" size="small" weight="regular" color={textColor}>
            {label}
          </Typography>
        </Flex>
        <IconButton aria-label={'delete'} onClick={onRemove} variant={'ghost'} data-testid={'remove-assistant'}>
          <Box w={'16px'}>
            <TrashIcon variantColor="error.main" />
          </Box>
        </IconButton>
      </Flex>
    </Flex>
  );
}
